import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { CommonConfig } from "CommonConfig";
import GridContainer from "components/Grid/GridContainer";
import { InputText } from "primereact/inputtext";
import api from "utils/api";
import APIConstant from "utils/constant";
import GridItem from "components/Grid/GridItem";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import cogoToast from "cogo-toast";
import Datetime from "react-datetime";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";

const initialNameState = {
  name: "",
  error: false,
  errorText: "",
};

const LoyaltyProgram = (props) => {
  const [userId, setUserId] = useState("");
  const [loyaltyId, setLoyaltyId] = useState("");
  const [loyaltyDetailsId, setLoyaltyDetailsId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [addDialog, setAddDialog] = useState(false);
  const [tierDialog, setTierDialog] = useState(false);
  const [expandedRows, setExpandedRows] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [detailsReadOnly, setDetailsReadOnly] = useState(false);
  const [search, setSearch] = useState("");
  const [programName, setProgramName] = useState(initialNameState);
  const [loyaltyRewardList, setLoyatyRewardList] = useState([]);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );
  const [tierData, setTierData] = useState({
    name: "",
    nameErr: "",
    nameErrText: "",
    applicableDate: "",
    applicableDateErr: "",
    applicableDateErrText: "",
    expiryDays: "",
    expiryDaysErr: "",
    expiryDaysErrText: "",
    rows: [createEmptyTierRow()],
  });

  function createEmptyTierRow() {
    return {
      min: "",
      max: "",
      type: "",
      multiple: "",
      points: "",
    };
  }

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
      setUserPageAccess(userPageAccess);
      getLoyaltyRewardList();
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  const getLoyaltyRewardList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetLoyaltyReward, params)
      .then((response) => {
        if (response.Success === 1) {
          setLoyatyRewardList(response.Data);
        }
      })
      .catch((err) => {});
  };

  const addUpdateLoyaltyReward = async () => {
    let params = {
      LoyaltyId: loyaltyId,
      UserId: userId,
      Name: programName.name,
    };
    api
      .post(APIConstant.path.AddUpdateLoyaltyReward, params)
      .then((response) => {
        if (response.Success === 1) {
          handleClose("AddDialog");
          getLoyaltyRewardList();
          cogoToast.success(response.Message);
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch((err) => {});
  };

  const getLoyaltyRewardById = async (id) => {
    let params = {
      LoyaltyId: id,
      UserId: userId,
    };
    api
      .post(APIConstant.path.GetLoyaltyRewardById, params)
      .then((response) => {
        if (response.Success === 1) {
          let data = response.Data;
          setProgramName({
            name: data.Name,
            error: false,
            errorText: "",
          });
        }
      })
      .catch((err) => {});
  };

  const getLoyaltyRewardDetailsById = async (id) => {
    let params = {
      DetailsId: id,
      UserId: userId,
    };
    api
      .post(APIConstant.path.GetLoyaltyRewardDetailsById, params)
      .then((response) => {
        if (response.Success === 1) {
          let data = response.Data.Details;
          setTierData({
            name: data.Name,
            applicableDate: data.ApplicableDate,
            expiryDays: data.ExpiryDays,
            rows: data.Tiers,
          });
        }
      })
      .catch((err) => {});
  };

  const deleteLoyaltyReward = async () => {
    let params = {
      LoyaltyId: loyaltyId,
      UserId: userId,
    };
    api
      .post(APIConstant.path.DeleteLoyaltyReward, params)
      .then((response) => {
        if (response.Success === 1) {
          handleClose("DeleteMasterType");
          cogoToast.success(response.Message);
          getLoyaltyRewardList();
        }
      })
      .catch((err) => {});
  };

  const updateLoyaltyDetail = async () => {
    if (validateDetails()) {
      const payload = {
        LoyaltyId: loyaltyId,
        DetailsId: loyaltyDetailsId,
        UserId: userId,
        Details: [
          {
            Name: tierData.name,
            ApplicableDate: tierData.applicableDate,
            ExpiryDays: tierData.expiryDays,
            Tiers: tierData.rows,
          },
        ],
      };
      api
        .post(APIConstant.path.UpdateLoyaltyRewardDetails, payload)
        .then((res) => {
          if (res.Success === 1) {
            handleClose("TierDialog");
            getLoyaltyRewardList();
            cogoToast.success("Tier updated successfully");
          } else {
            cogoToast.error("Error updating tier");
          }
        });
    }
  };

  const UpdateTierStatus = async (TierId, TierStatus) => {
    const payload = {
      TierId,
      TierStatus,
    };
    api.post(APIConstant.path.UpdateTierStatus, payload).then((res) => {
      if (res.Success === 1) {
      } else {
        cogoToast.error("Error updating tier");
      }
    });
  };

  const validateDetails = () => {
    let isValid = true;
    let errorObj = {};
    if (CommonConfig.isEmpty(tierData.name)) {
      isValid = false;
      errorObj.nameErr = true;
      errorObj.nameErrText = "Please enter name";
    } else {
      errorObj.nameErr = false;
      errorObj.nameErrText = "";
    }
    if (CommonConfig.isEmpty(tierData.applicableDate)) {
      isValid = false;
      errorObj.applicableDateErr = true;
      errorObj.applicableDateErrText = "Please enter date";
    } else {
      errorObj.applicableDateErr = false;
      errorObj.applicableDateErrText = "";
    }
    if (CommonConfig.isEmpty(tierData.expiryDays)) {
      isValid = false;
      errorObj.expiryDaysErr = true;
      errorObj.expiryDaysErrText = "Please enter expiry";
    } else {
      errorObj.expiryDaysErr = false;
      errorObj.expiryDaysErrText = "";
    }
    if (tierData.rows && tierData.rows.length) {
      tierData.rows.forEach((item) => {
        if (CommonConfig.isEmpty(item.min)) {
          isValid = false;
        } else if (CommonConfig.isEmpty(item.max)) {
          isValid = false;
        } else if (CommonConfig.isEmpty(item.type)) {
          isValid = false;
        } else if (
          item.type === "MULTIPLE" &&
          CommonConfig.isEmpty(item.multiple)
        ) {
          isValid = false;
        } else if (CommonConfig.isEmpty(item.points)) {
          isValid = false;
        }
        if (!isValid) {
          cogoToast.error("Please fill the details");
        }
      });
    }
    setTierData((prevState) => ({
      ...prevState,
      ...errorObj,
    }));

    return isValid;
  };

  const actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {userPageAccess.includes("View Loyalty Reward") ? (
          <i
            class="icon-view"
            onClick={(e) => handleOpen(rowData, "ViewMasterType")}
          ></i>
        ) : null}
        {userPageAccess.includes("Edit Loyalty Reward") ? (
          <i
            onClick={(e) => handleOpen(rowData, "EditMasterType")}
            class="icon-editImage"
          ></i>
        ) : null}
        {userPageAccess.includes("Delete Loyalty Reward") ? (
          <i
            onClick={(e) => handleOpen(rowData, "DeleteMasterType")}
            class="icon-delete"
          ></i>
        ) : null}
        {userPageAccess.includes("Add Loyalty Reward") ? (
          <i
            onClick={() => handleOpen(rowData, "TierDialog")}
            class="icon-add"
          ></i>
        ) : null}
      </div>
    );
  };

  const actionDetailTemplate = (rowData) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {userPageAccess.includes("View Loyalty Reward") ? (
          <i
            class="icon-view"
            onClick={(e) => {
              handleOpen(rowData, "ViewTierDialog");
            }}
          ></i>
        ) : null}
        {userPageAccess.includes("Edit Loyalty Reward") ? (
          <i
            onClick={(e) => {
              handleOpen(rowData, "EditTierDialog");
            }}
            class="icon-editImage"
          ></i>
        ) : null}
      </div>
    );
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const actionSwitchTemplate = (rowData, props, parentIndex) => {
    return (
      <InputSwitch
        checked={rowData.TierStatus}
        onChange={(e) => {
          let tempList = [...loyaltyRewardList];
          tempList[parentIndex].Details[props.rowIndex].TierStatus = e.value;
          setLoyatyRewardList(tempList);
          UpdateTierStatus(rowData._id, e.value);
        }}
      />
    );
  };

  const handleOpen = async (e, type) => {
    if (type === "AddDialog") {
      setAddDialog(true);
    } else if (type === "ViewMasterType") {
      setLoyaltyId(e._id);
      await getLoyaltyRewardById(e._id);
      setReadOnly(true);
      setAddDialog(true);
    } else if (type === "EditMasterType") {
      setLoyaltyId(e._id);
      await getLoyaltyRewardById(e._id);
      setAddDialog(true);
    } else if (type === "DeleteMasterType") {
      setLoyaltyId(e._id);
      setDeleteDialog(true);
    } else if (type === "TierDialog") {
      setLoyaltyId(e._id);
      setTierDialog(true);
    } else if (type === "ViewTierDialog") {
      setLoyaltyDetailsId(e._id);
      await getLoyaltyRewardDetailsById(e._id);
      setDetailsReadOnly(true);
      setTierDialog(true);
    } else if (type === "EditTierDialog") {
      setLoyaltyDetailsId(e._id);
      await getLoyaltyRewardDetailsById(e._id);
      setTierDialog(true);
    }
  };

  const handleChange = async (e, type) => {
    if (type === "programName") {
      if (CommonConfig.isObjectEmpty(e?.target?.value)) {
        setProgramName({
          name: "",
          error: true,
          errorText: "Please enter program name",
        });
      } else {
        setProgramName({
          name: e.target.value,
          error: false,
          errorText: "",
        });
      }
    }
  };

  const handleClose = (type) => {
    if (type === "AddDialog") {
      setAddDialog(false);
      setProgramName(initialNameState);
      setReadOnly(false);
      setLoyaltyId("");
    } else if (type === "DeleteMasterType") {
      setDeleteDialog(false);
      setLoyaltyId("");
    } else if (type === "TierDialog") {
      setTierDialog(false);
      setTierData({
        name: "",
        applicableDate: "",
        expiryDays: "",
        rows: [createEmptyTierRow()],
      });
      setLoyaltyId("");
      setDetailsReadOnly(false);
      setLoyaltyDetailsId("");
    }
  };

  const handleTierChange = (index, field, value, regex) => {
    const newRows = [...tierData.rows];
    if (field === "type" && value === "FIXED") {
      newRows[index].multiple = "";
    }
    if (!regex || regex.test(value)) newRows[index][field] = value;
    setTierData({ ...tierData, rows: newRows });
  };

  const handleAddTierRow = () => {
    setTierData({
      ...tierData,
      rows: [...tierData.rows, createEmptyTierRow()],
    });
  };

  const handleDeleteTierRow = (index) => {
    const newRows = tierData.rows.filter((_, i) => i !== index);
    setTierData({ ...tierData, rows: newRows });
  };

  const renderDetailsTable = (rowData, props) => {
    const tiers = rowData.Details || [];
    let parentIndex = loyaltyRewardList.findIndex(
      (item) => item._id === rowData._id
    );
    return (
      <DataTable value={tiers}>
        <Column header="Sr No" body={(data, props) => props.rowIndex + 1} />
        <Column field="Name" header="Name/Tier" />
        <Column
          field="ApplicableDate"
          header="Applicable Date"
          body={(data) =>
            data.ApplicableDate
              ? moment(data.ApplicableDate).format("DD/MM/YYYY")
              : "-"
          }
        />
        <Column
          field="EndDate"
          header="End Date"
          body={(data) =>
            data.EndDate ? moment(data.EndDate).format("DD/MM/YYYY") : "-"
          }
        />
        <Column field="ExpiryDays" header="Expiry Days" />
        <Column
          field="TierStatus"
          header="Status"
          body={(data, childProps) =>
            actionSwitchTemplate(data, childProps, parentIndex)
          }
        />
        <Column field="Action" header="Action" body={actionDetailTemplate} />
      </DataTable>
    );
  };

  const allowExpansion = (rowData) => {
    return rowData.orders.length > 0;
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-sun"></i>
          <h2>Loyalty Reward</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-as-center">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 10 }}
            />
            <i className="icon-search"></i>
          </div>
          {userPageAccess.includes("Add Loyalty Reward") ? (
            <div>
              <div
                className="e-add-btn"
                onClick={(e) => handleOpen(e, "AddDialog")}
              >
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />

      <div className="main-access-card-master ">
        <DataTable
          className="main-table table-td"
          // style={{ height: "calc(100vh - 196px)" }}
          expandedRows={expandedRows}
          onRowToggle={(e) => {
            setExpandedRows(e.data);
          }}
          rowExpansionTemplate={renderDetailsTable}
          value={loyaltyRewardList}
          editMode="row"
          dataKey="_id"
          responsiveLayout="scroll"
          paginator={true}
          rows={rowsPerPage}
          totalRecords={loyaltyRewardList.length}
          rowsPerPageOptions={rowsPerPageOptions}
          globalFilter={search}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column expander={allowExpansion} style={{ width: "5%" }} />
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "20%" }}
          ></Column>
          <Column
            field="Name"
            header="Program Name"
            style={{ width: "20%" }}
          ></Column>

          <Column
            field="Action"
            header="Action"
            body={actionTemplate}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        className="stock-modal"
        open={addDialog}
        onClose={() => handleClose("AddDialog")}
        aria-labelledby="cha-form-dialog-title"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Program Name</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("AddDialog")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <GridContainer>
          <GridItem md={12}>
            <TextField
              autoFocus
              margin="dense"
              name="program name"
              label="Program Name"
              type="text"
              value={programName.name}
              onChange={(e) => handleChange(e, "programName")}
              error={programName.error}
              helperText={programName.errorText}
              inputProps={{ maxLength: 50 }}
              fullWidth
              disabled={readOnly}
            />
          </GridItem>
        </GridContainer>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("AddDialog")}
          >
            Cancel
          </Button>
          {!readOnly && (
            <Button
              className="primary-btn"
              onClick={(e) => addUpdateLoyaltyReward(e)}
              type="submit"
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDialog}
        onClose={() => handleClose("DeleteMasterType")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Program</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("DeleteMasterType")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("DeleteMasterType")}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteLoyaltyReward(e)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={tierDialog}
        onClose={() => handleClose("TierDialog")}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Add Tier</DialogTitle>
        <DialogContent>
          <GridContainer>
            <GridItem xs={12} md={4}>
              <TextField
                label="Name / Tier"
                fullWidth
                value={tierData.name}
                onChange={(e) =>
                  setTierData({
                    ...tierData,
                    name: e.target.value,
                    nameErr: !!CommonConfig.isEmpty(e.target.value),
                    nameErrText: CommonConfig.isEmpty(e.target.value)
                      ? "Please enter name"
                      : "",
                  })
                }
                inputProps={{ maxLength: 50 }}
                disabled={detailsReadOnly}
                error={tierData.nameErr}
                helperText={tierData.nameErrText}
                margin="dense"
              />
            </GridItem>

            <GridItem xs={12} md={4}>
              <Datetime
                className="p-mt-1"
                value={moment(tierData.applicableDate)}
                onChange={(e) =>
                  setTierData({
                    ...tierData,
                    applicableDate: e,
                    applicableDateErr: !!CommonConfig.isEmpty(e),
                    applicableDateErrText: CommonConfig.isEmpty(e)
                      ? "Please enter date"
                      : "",
                  })
                }
                disabled={detailsReadOnly}
                closeOnSelect={true}
                timeFormat={false}
                dateFormat="DD/MM/YY"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Applicable Date"
                    disabled={detailsReadOnly}
                    fullWidth
                    className="input-box"
                    error={tierData.applicableDateErr}
                    helperText={tierData.applicableDateErrText}
                  />
                )}
              />
            </GridItem>
            <GridItem xs={12} md={4}>
              <TextField
                label="Expiry Days"
                fullWidth
                value={tierData.expiryDays}
                onChange={(e) => {
                  if (CommonConfig.isEmpty(e?.target?.value)) {
                    setTierData({
                      ...tierData,
                      expiryDays: "",
                      expiryDaysErr: true,
                      expiryDaysErrText: "Please enter expiry",
                    });
                  } else {
                    if (/^\d*$/i.test(e.target.value)) {
                      setTierData({
                        ...tierData,
                        expiryDays: e.target.value,
                        expiryDaysErr: false,
                        expiryDaysErrText: "",
                      });
                    }
                  }
                }}
                inputProps={{ maxLength: 5 }}
                disabled={detailsReadOnly}
                error={tierData.expiryDaysErr}
                helperText={tierData.expiryDaysErrText}
                margin="dense"
              />
            </GridItem>
          </GridContainer>
          <DataTable
            className="main-table table-td"
            value={tierData.rows}
            editMode="row"
          >
            <Column header="Sr No" body={(_, props) => props.rowIndex + 1} />
            <Column
              header="MIN"
              body={(row, props) =>
                detailsReadOnly ? (
                  row.min
                ) : (
                  <InputText
                    value={row.min}
                    maxLength={10}
                    onChange={(e) =>
                      handleTierChange(
                        props.rowIndex,
                        "min",
                        e.target.value,
                        /^\d*$/
                      )
                    }
                  />
                )
              }
            />
            <Column
              header="MAX"
              body={(row, props) =>
                detailsReadOnly ? (
                  row.max
                ) : (
                  <InputText
                    value={row.max}
                    maxLength={10}
                    onChange={(e) =>
                      handleTierChange(
                        props.rowIndex,
                        "max",
                        e.target.value,
                        /^\d*$/
                      )
                    }
                  />
                )
              }
            />
            <Column
              header="TYPE"
              body={(row, props) =>
                detailsReadOnly ? (
                  row.type
                ) : (
                  <Dropdown
                    options={[
                      { label: "FIXED", value: "FIXED" },
                      { label: "MULTIPLE", value: "MULTIPLE" },
                    ]}
                    value={row.type}
                    onChange={(e) =>
                      handleTierChange(props.rowIndex, "type", e.value)
                    }
                    optionLabel="label"
                  />
                )
              }
            />
            <Column
              header="MULTIPLE"
              body={(row, props) =>
                detailsReadOnly ? (
                  row.multiple
                ) : (
                  <InputText
                    disabled={row.type !== "MULTIPLE"}
                    value={row.multiple}
                    maxLength={10}
                    onChange={(e) =>
                      handleTierChange(
                        props.rowIndex,
                        "multiple",
                        e.target.value,
                        /^\d*$/
                      )
                    }
                  />
                )
              }
            />
            <Column
              header="POINTS"
              body={(row, props) =>
                detailsReadOnly ? (
                  row.points
                ) : (
                  <InputText
                    value={row.points}
                    maxLength={10}
                    onChange={(e) =>
                      handleTierChange(
                        props.rowIndex,
                        "points",
                        e.target.value,
                        /^\d*$/
                      )
                    }
                  />
                )
              }
            />
            <Column
              header="ACTION"
              body={(_, props) =>
                detailsReadOnly ? (
                  "-"
                ) : (
                  <div>
                    {tierData.rows.length - 1 === props.rowIndex && (
                      <Button
                        icon="pi pi-plus"
                        onClick={handleAddTierRow}
                        className="p-button-text"
                      />
                    )}
                    {tierData.rows.length > 1 && (
                      <Button
                        icon="pi pi-trash"
                        onClick={() => handleDeleteTierRow(props.rowIndex)}
                        className="p-button-text"
                      />
                    )}
                  </div>
                )
              }
            />
          </DataTable>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose("TierDialog")}>Cancel</Button>
          {!detailsReadOnly && (
            <Button onClick={updateLoyaltyDetail}>Submit</Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LoyaltyProgram;
